import { useState, useRef, useEffect } from 'react'
import { Icon } from '@/components/ui/Icon'

interface HowWeKnowProps {
  signals: string[]
  confidence: number
}

export function HowWeKnow({ signals, confidence }: HowWeKnowProps) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLSpanElement>(null)
  const pct = Math.round(confidence * 100)
  const tier = confidence >= 0.8 ? 'high' : confidence >= 0.55 ? 'medium' : 'low'

  useEffect(() => {
    if (!open) return
    function onDoc(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onDoc)
    return () => document.removeEventListener('mousedown', onDoc)
  }, [open])

  return (
    <span className="cg-hwk-wrap" ref={ref}>
      <button
        className="cg-hwk-trigger"
        data-tier={tier}
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o) }}
        title="How we know"
      >
        ~
      </button>
      {open && (
        <div className="cg-hwk-pop" onClick={(e) => e.stopPropagation()}>
          <div className="cg-hwk-header">
            <span className="cg-hwk-eyebrow">How we know</span>
            <button className="cg-icon-btn" onClick={() => setOpen(false)}>
              <Icon name="x" size={11} />
            </button>
          </div>
          <div className="cg-hwk-confidence">
            <span className="cg-hwk-conf-label">Confidence</span>
            <span className="cg-hwk-bar">
              <span className="cg-hwk-bar-fill" data-tier={tier} style={{ width: `${pct}%` }} />
            </span>
            <span className="cg-hwk-pct">{pct}%</span>
          </div>
          <ul className="cg-hwk-signals">
            {signals.length === 0 && (
              <li className="cg-hwk-empty">No strong signals — best guess only.</li>
            )}
            {signals.map((s, i) => (
              <li key={i}>
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 6l3 3 5-6" />
                </svg>
                {s}
              </li>
            ))}
          </ul>
          <div className="cg-hwk-foot">
            Steam doesn't expose co-play data. We infer it from achievement timestamps + last-played stamps.
          </div>
        </div>
      )}
    </span>
  )
}
